module.exports = __webpack_public_path__ + "static/media/mssg_getstarted_pt_BR.52489786.png";